const VConsole = require('vconsole')
const axios = require('axios')
const myPlugin = new VConsole.VConsolePlugin('colorSwitch', '染色环境')

myPlugin.on('renderTab', function(callback) {
  const currentEnv = localStorage.getItem('x-infr-flowtype')
  // 在这里可以初始化一些自用的配置
  axios
    .get('https://polaris.shizhuang-inc.com/api/v1/ep-dyeing/open?env=i-mf1')
    .then((res) => {
      let data =
        res?.data?.results.map((item) => {
          return {
            label: item.name,
            value: `${item.name}`
          }
        }) || []

      data = [{ label: '无', value: '' }, ...data]

      const html = `
      <div>
        ${data
          .map(
            (item) => `
          <div
            style="margin: 5px;color: #0550ae;"
          >
            <input class="color-radio-env" name="color" ${
              item.value === currentEnv ? 'checked' : ''
            } type="radio" value="${item.value}" id="${
              item.value
            }-radio"></input>
            <label for="${item.value}-radio">${item.label}</label>
          </div>`
          )
          .join('')}
      </div>
    `
      callback(html)
    })

  callback(
    `<div style="margin: 5px">当前染色环境: <span style="color: #cf222e;">${currentEnv ||
      '无'}</span><div>下方选择然后点击刷新按钮生效</div></div>`
  )
})

myPlugin.on('addTool', function(callback) {
  const button = {
    name: '刷新',
    onClick() {
      const radioList = document.querySelectorAll('.color-radio-env')
      const find = [...radioList].find((item) => item.checked)
      if (!find) {
        alert('请选择染色环境!')
      }
      localStorage.setItem('x-infr-flowtype', find.value)
      window.location.reload()
    }
  }
  callback([button])
})

module.exports = myPlugin
